module.exports = __webpack_public_path__ + "static/media/magazineTupp_02_full.ddeb6290.jpg";